import { StandardEvents } from '@shopify/events';

/**
 * Hands the cart over to Rebuy Smart Cart (LIV-229) when the theme setting
 * "Use Rebuy Smart Cart" is on and Smart Cart is live on the storefront
 * (enabled in Rebuy admin). Until then `window.Rebuy.SmartCart` is undefined
 * and the native cart drawer keeps working unchanged.
 *
 * - Header cart button opens Smart Cart instead of the native drawer.
 * - After an add to cart, Smart Cart refreshes and opens; `cart-drawer.js`
 *   skips its own auto-open via `isRebuySmartCartActive()`.
 */

/** @returns {any} */
function smartCart() {
  return /** @type {any} */ (window).Rebuy?.SmartCart;
}

function isRebuySmartCartActive() {
  return document.body.hasAttribute('data-rebuy-smart-cart') && Boolean(smartCart());
}

window.addEventListener(
  'click',
  (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-cart-trigger]') : null;
    if (!trigger || !isRebuySmartCartActive()) return;

    // Window capture phase runs before the theme's delegated `on:click`
    // listeners on document, so the native drawer's toggle never fires.
    event.preventDefault();
    event.stopImmediatePropagation();
    smartCart().show();
  },
  true
);

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (!isRebuySmartCartActive() || /** @type {any} */ (event).action !== 'add') return;

  const open = async () => {
    const rebuy = /** @type {any} */ (window).Rebuy;
    await rebuy.Cart?.fetchCart?.();
    smartCart().show();
  };

  const promise = /** @type {any} */ (event).promise;
  if (promise) {
    promise.then(({ detail } = {}) => !detail?.didError && open()).catch(() => {});
  } else {
    open();
  }
});
